import { InputAdornment } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { action, API, controller } from "api";
import { formatDecimal, ToFormData } from "hooks";
import { Button, ComponentLoader, Input } from "controls";
import { toast } from "react-toastify";
import { AppContext } from "App";
import { useNavigate } from "react-router-dom";

const UpdatePrices = ({ selectedRec, setShowForm }) => {
  const { setLoader, loader } = useContext(AppContext);
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setShowForm((j) => !j);
  };

  useEffect(() => {
    setLoading(true);
    API(controller.Product + action.GetProdDetailsForUpdatePrice).post(
      ToFormData({ all: selectedRec?.all, ids: selectedRec?.items }),
      (res) => {
        res?.status === 200 && setProducts([...res.result]);
        setLoading(false);
      }
    );
    return () => {};
  }, [selectedRec]);

  const handleInpChg = (e, prod) => {
    const { name, value } = e.target;
    setProducts((prev) =>
      prev.map((p) => (p.prodId === prod.prodId ? { ...p, [name]: value } : p))
    );
  };

  const handleSubmit = () => {
    if (products.length > 0) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res?.status === 200) {
          handleClose();
          toast.success("Success! All prices has been changed.");
          // reload the page
          navigate(0);
        } else toast.error(`Error: ${res}`);
      };

      API(controller.Product + action.UpdatePrices).post(
        ToFormData(
          products.map((j) => ({
            ...j,
            updateDate: new Date().toUTCString(),
          })),
          new FormData(),
          "products"
        ),
        onComplete
      );
    } else toast.error("Edit list is empty.");
  };

  return (
    <div className="flex flex-col max-h-[90vh]">
      {/* ======= Header ======== */}
      <div className="flex justify-between items-center gap-2 border-b p-[5px]">
        <span className="text-[20px] ml-[10px] uppercase text-gray-500 font-medium">
          Edit supply and retail prices on{" "}
          <span className="font-bold text-gray-600">{products.length}</span>{" "}
          selected SKUs
        </span>
        <div className="flex gap-2">
          <Button onClick={handleClose} variant="text">
            Close
          </Button>
          <Button loading={loader} onClick={handleSubmit}>
            Save Changes
          </Button>
        </div>
      </div>
      {/* ======= Body ======== */}
      <div className="flex-1 overflow-y-auto flex flex-col gap-5">
        {!loading ? (
          <TableContainer className="max-h-[500px] overflow-auto">
            <Table className="min-w-[650px]" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="!text-gray-500">SKU</TableCell>
                  <TableCell className="!text-gray-500">
                    Latest Cost Price
                  </TableCell>
                  <TableCell className="!text-gray-500">Supply Price</TableCell>
                  <TableCell className="!text-gray-500">Retail Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((prod, ind) => (
                  <TableRow key={ind} hover>
                    <TableCell>
                      <div className="flex flex-col">
                        <span className="text-[16px] text-gray-600">
                          {prod.label}
                        </span>
                        <span className="text-gray-500 font-medium text-[12px] tracking-wider">
                          {prod.skuCode}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span className="text-[16px] text-gray-500">
                        {prod.latestCostPrice
                          ? `$ ${formatDecimal(prod.latestCostPrice, true)}`
                          : "-"}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Input
                        variant="outlined"
                        placeholder="0.00"
                        size="small"
                        defaultValue={prod.splrPrice || ""}
                        name="splrPrice"
                        onBlur={(e) => handleInpChg(e, prod)}
                        type="number"
                        onFocus={(e) => e.target.select()}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          minWidth: "120px",
                          "& .MuiInputBase-input": {
                            padding: "6px 10px",
                            fontSize: "14px",
                            paddingLeft: "0px",
                          },
                          ".MuiOutlinedInput-root ": {
                            paddingLeft: "8px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Input
                        variant="outlined"
                        placeholder="0.00"
                        size="small"
                        defaultValue={prod.rtlPrice || ""}
                        name="rtlPrice"
                        onBlur={(e) => handleInpChg(e, prod)}
                        type="number"
                        onFocus={(e) => e.target.select()}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          minWidth: "120px",
                          "& .MuiInputBase-input": {
                            padding: "6px 10px",
                            fontSize: "14px",
                            paddingLeft: "0px",
                          },
                          ".MuiOutlinedInput-root ": {
                            paddingLeft: "8px",
                          },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className="min-h-[300px] justify-center items-center flex">
            <ComponentLoader show={loading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdatePrices;
